import React from "react";
import "./App.css";
import LandingPage from "./pages/LandingPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ImagesGallary from "./pages/ImagesGallary";
import UploadWidget from "./components/UploadWidget";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/gallary" element={<ImagesGallary />} />
            <Route path="/admin" element={<UploadWidget />} />
          </Routes>
        </Router>
      </div>
    </ThemeProvider>
  );
}

export default App;
